/* eslint-disable */
import axios from '@/services/axios'

export default {
    getCategories() {
        return axios.get("/info/categories");
    },
    getApiFrameworks() {
        return axios.get("/info/api-frameworks");
    },
    getApiAttributes() {
        return axios.get("/info/attributes");
    },
    getCountries(search) {
        return axios.get("/country/search", {
            params: search
        });
    },
    getAudiences() {
        return axios.get("/info/audiences");
    },
    getExchanges() {
        return axios.get("/info/exchanges");
    },
    getRoles() {
        return axios.get("/roles/search");
    },
    getRolesSuper() {
        return axios.get("/roles/searchsuper");
    },
    test() {
        return axios.get("/schedule/test");
    }
};
